export default __webpack_public_path__ + "content/media/23.46e7cd94.jpg";